/* unplugin-vue-components disabled */import { render } from "./SliderColumn.vue?vue&type=template&id=6b85782e&scoped=true"
import script from "./SliderColumn.vue?vue&type=script&lang=js"
export * from "./SliderColumn.vue?vue&type=script&lang=js"

import "./SliderColumn.vue?vue&type=style&index=0&id=6b85782e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b85782e"]])

export default __exports__